var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service } from "@bluelibs/core";
import * as Ant from "antd";
import { UsersCollection, } from "@bundles/UIAppBundle/collections";
import { UserRole } from "@root/api.types";
let ExternalListFiltersForm = class ExternalListFiltersForm extends XForm {
    build(userRoles) {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "createdAt",
                label: t("management.externals.fields.createdAt"),
                name: ["createdAt"],
                tooltip: t("management.externals.fields.createdAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "updatedAt",
                label: t("management.externals.fields.updatedAt"),
                name: ["updatedAt"],
                tooltip: t("management.externals.fields.updatedAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "name",
                label: t("management.externals.fields.name"),
                name: ["name"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "email",
                label: t("management.externals.fields.email"),
                name: ["email"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "phone",
                label: t("management.externals.fields.phone"),
                name: ["phone"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "address",
                label: t("management.externals.fields.address"),
                name: ["address"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "city",
                label: t("management.externals.fields.city"),
                name: ["city"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "state",
                label: t("management.externals.fields.state"),
                name: ["state"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "zip",
                label: t("management.externals.fields.zip"),
                name: ["zip"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "country",
                label: t("management.externals.fields.country"),
                name: ["country"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "website",
                label: t("management.externals.fields.website"),
                name: ["website"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "targetBankAccount",
                label: t("management.externals.fields.targetBankAccount"),
                name: ["targetBankAccount"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "targetBankName",
                label: t("management.externals.fields.targetBankName"),
                name: ["targetBankName"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "type",
                label: t("management.externals.fields.type"),
                name: ["type"],
                tooltip: t("management.externals.fields.type_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            ...(userRoles.includes(UserRole.ADMIN)
                ? [
                    {
                        id: "responsibleUserId",
                        label: t("management.externals.fields.responsibleUser"),
                        name: ["responsibleUserId"],
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                    {
                        id: "createdById",
                        label: t("management.externals.fields.createdBy"),
                        name: ["createdById"],
                        tooltip: t("management.externals.fields.createdBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                    {
                        id: "updatedById",
                        label: t("management.externals.fields.updatedBy"),
                        name: ["updatedById"],
                        tooltip: t("management.externals.fields.updatedBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                ]
                : []),
        ]);
    }
};
ExternalListFiltersForm = __decorate([
    Service({ transient: true })
], ExternalListFiltersForm);
export { ExternalListFiltersForm };
